import { render, staticRenderFns } from "./kiosk-re-coin-list.vue?vue&type=template&id=045aed26&scoped=true&"
import script from "./kiosk-re-coin-list.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-coin-list.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-re-coin-list.vue?vue&type=style&index=0&id=045aed26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045aed26",
  null
  
)

export default component.exports